import React, { useState, useEffect, Fragment } from 'react';
import { segmentTrackEvent } from '../utils';
import Slider from 'react-slick';

const PrevArrow = (props) => {
  const {onClick} = props;

  return (
    <div className="icon-thin-arrow left-arrow" onClick={onClick}></div>
  );
}

const NextArrow = (props) => {
  const {onClick} = props;

  return (
    <div className="icon-thin-arrow right-arrow" onClick={onClick}></div>
  );
}

const handleLinkClick = (e) => {
  const { target } = e;
  const targetTagName = target.tagName.toLowerCase();
  let trackableElement = target;
  let innerHTML = '';
  if ((targetTagName === 'a') || ((targetTagName === 'img') && (target.parentNode.tagName.toLowerCase() === 'a')) || this.props.dataEventName) {
    if (targetTagName === 'img') {
      trackableElement = target.parentNode;
      innerHTML = target.src.substring(target.src.lastIndexOf('/') + 1).split('?')[0];
    } else {
      ({ innerHTML } = target);
    }
  }
  const destinationUrl = trackableElement.getAttribute('href');
  const linkType = trackableElement.getAttribute('data-link-type') || 'text-link';
  const articleClickedTracker = {
    destinationUrl,
    module: 'featured-section',
    category: linkType,
    linkType,
    label: `${innerHTML} hyperlink`,
  };
  segmentTrackEvent('article_link_clicked', articleClickedTracker);
};

const FeaturedSection = ({
  section,
  sectionIndex,
  isMobile,
  pinkImage,
}) => {
  const { direction, color, editor, title, added, cut, shoppable, bgImage } = section;
  let bgImg = isMobile ? bgImage.mobile : bgImage.desktop;
  let pinkBg = isMobile ? pinkImage.mobile : pinkImage.desktop;

  const renderedProducts = shoppable.map((product, i) => {

    const productButtonTracker = {
      destinationUrl: product.url,
      module: 'section',
      category: 'data-link-type',
      linkType: 'data-link-type',
      label: product.name,
    };

    return (
      <div className="featured-product">
        <a href={product.url} target="_blank" onClick={() => { segmentTrackEvent('product_clicked', productButtonTracker); }}>
          <img className="product-image" src={product.image} />
          <h3 className="product-name">{product.name}</h3>
        </a>
        <a href={product.url} className="product-cta" target="_blank" onClick={() => { segmentTrackEvent('product_clicked_cta', productButtonTracker); }}>{product.cta}</a>
      </div>
    )
  });

    let settings = {
      dots: false,
      arrows: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerPadding: "50px",
      touchMove: true,
      swipeToSlide: true,
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />  
    };

  return (
    <Fragment>
      <img className="pink-background" src={pinkBg}/>
      <div id="section" className="featured-section">
        <img className="featured-image" src={bgImg}/>
        <div className="section-text-container">
            <div className={`editor-wrapper ${direction}`}>
              <h3 className="editor">{editor}</h3>
              <h4 className="title">{title}</h4>
            </div>
            <div className={`section-text-wrapper ${color}`}>
              <h3 className="section-subhed">wish we added:</h3>
              <div className="section-text" dangerouslySetInnerHTML={{ __html: added }} onClick={e => handleLinkClick(e)}/>
              <h3 className="section-subhed">wish we cut:</h3>
              <div className="section-text" dangerouslySetInnerHTML={{ __html: cut }} onClick={e => handleLinkClick(e)}/>
            </div>
        </div>
        <div className="featured-shoppable">
        { isMobile ? (
            <Slider {...settings}>
              {renderedProducts}
            </Slider>
        ) : (
          <Fragment>
            {renderedProducts}
          </Fragment>
        )}
        </div>
      </div>
    </Fragment>
  );
};

export default FeaturedSection;